import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./not-found.page.scss";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
    const navigate = useNavigate();
    const clickBack = () => {
        navigate("/")
    }

    return (
        <div className="not-found-control">
            <div className="not-found-item-control">
                <FontAwesomeIcon icon={faWarning} className="icon"></FontAwesomeIcon>
                <span className="text-bold">ไม่พบหน้าที่คุณค้นหา</span>
                <Button className="button-std" onClick={clickBack}>กลับหน้าหลัก</Button>
            </div>
        </div>
    )
}

export default NotFoundPage;